module.exports = __webpack_public_path__ + "img/404-2.410d7eb1.png";